module.exports = __webpack_public_path__ + "assets/img/store-banner-01.a128eb54.png";